import React from 'react';

import { TableCell, TableRow } from '@occc/ui-design-system';
import { displayAmount } from '@occc-app/lib/currency';
import { TRANSACTION_DISCOUNT } from '@occc-app/routes/Transactions/TransactionView/utils';

import { TransactionViewItemData, TransactionViewItemOptionalColumns } from './types';
import { TransactionViewTableCell } from './TransactionViewTableCell';

const NO_VALUE_PLACEHOLDER = '-';

export const TransactionViewItem = (props: {
  item: TransactionViewItemData;
  hideColumns?: TransactionViewItemOptionalColumns[];
  children?: React.ReactNode;
}) => {
  const {
    item: {
      name = NO_VALUE_PLACEHOLDER,
      group = NO_VALUE_PLACEHOLDER,
      sku = NO_VALUE_PLACEHOLDER,
      upc = NO_VALUE_PLACEHOLDER,
      quantity = NO_VALUE_PLACEHOLDER,
      quantityUnit,
      moneyAmount,
    },
    hideColumns = [],
    children,
  } = props;

  const noBottomBorder = !!children;
  const isDiscount = group === TRANSACTION_DISCOUNT;

  return (
    <>
      {isDiscount ? (
        name ? (
          <TableRow>
            <TransactionViewTableCell noBottomBorder={noBottomBorder} colSpan={6}>
              {name}
            </TransactionViewTableCell>
          </TableRow>
        ) : null
      ) : (
        <TableRow>
          <TransactionViewTableCell noBottomBorder={noBottomBorder}>
            {name}
          </TransactionViewTableCell>
          {!hideColumns.includes('group') && (
            <TransactionViewTableCell noBottomBorder={noBottomBorder}>
              {group}
            </TransactionViewTableCell>
          )}
          {!hideColumns.includes('sku') && (
            <TransactionViewTableCell noBottomBorder={noBottomBorder}>
              {sku}
            </TransactionViewTableCell>
          )}
          {!hideColumns.includes('upc') && (
            <TransactionViewTableCell noBottomBorder={noBottomBorder}>
              {upc}
            </TransactionViewTableCell>
          )}
          <TransactionViewTableCell align='right' noBottomBorder={noBottomBorder}>
            {quantity} {quantityUnit}
          </TransactionViewTableCell>
          <TransactionViewTableCell align='right' noBottomBorder={noBottomBorder}>
            {displayAmount(moneyAmount, false)}
          </TransactionViewTableCell>
        </TableRow>
      )}
      {children ? (
        <TableRow hover={false}>
          <TableCell
            colSpan={6 - hideColumns.length}
            sx={(theme) => ({
              '&:first-of-type': {
                padding: `${isDiscount && !name ? theme.spacing(1) : '0'} ${theme.spacing(
                  2,
                )} ${theme.spacing(1)} ${theme.spacing(2)}`,
              },
            })}
          >
            {children}
          </TableCell>
        </TableRow>
      ) : null}
    </>
  );
};
